import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Static SEO tags from index.html and the prerendered pages are for crawlers that
// don't run JavaScript. react-helmet-async writes its own, so drop these first.
document.querySelectorAll("head [data-prerender]").forEach((el) => el.remove());

createRoot(document.getElementById("root")!).render(<App />);
